module.exports = "<div class=\"row page-titles\">\r\n  <div class=\"col-md-5 align-self-center\">\r\n    <h5 class=\"text-headerbar\"><i class=\"fa fa-angle-right\"></i> {{ title }}</h5>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/headerbar/headerbar.component.html
// module id = ./src/app/components/headerbar/headerbar.component.html
// module chunks = main